import ProfessionnalAccount from './ProfessionnalAccount';
export default ProfessionnalAccount;
